import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	feedbackTitleNonFinal: {
		id: 'sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title-non-final',
		defaultMessage: 'Help us improve the new navigation',
		description: 'Message for the title of nav4 feedback collector modal',
	},
	feedbackTitleDetailsNonFinal: {
		id: 'sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title-details-non-final',
		defaultMessage: 'We’d love to hear about your experience with the new navigation.',
		description: 'Message for the sub-title of nav4 feedback collector modal',
	},
});
